import { RouterProvider, createHashRouter } from "react-router-dom";
import "./App.scss";
import Home from "./component/home/Home";
import Layout from "./component/layout/Layout";
// import { Spinner } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import Restaurant from "./component/restaurant/Restaurant";
import Menu from "./component/restaurant/Menu";
import Checkout from "./component/checkout/Checkout";
import Profile from "./component/profile/Profile";
import "react-toastify/dist/ReactToastify.css";
import OrderStatus from "./component/order/OrderStatus";
import AboutUs from "./component/aboutus/AboutUs";
import ContactUs from "./component/contactus/ContactUs";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "./component/widgets/Spinner";
import { useLayoutEffect } from "react";
import { updateDesktopMode } from "./redux/actions/generalActions";
import EditProfile from "./component/profile/EditProfile";
import Favorites from "./component/Favorites/Favorites";
import MyCart from "./component/common/MyCart";
import Info from "./component/restaurant/Info";
import Reviews from "./component/restaurant/Reviews";
import RestaurantDetails from "./component/restaurant/RestaurantDetails";
import RestaurantData from "./component/restaurant/RestaurantData";

export const router = createHashRouter([
  // {
  //   path: "*",
  //   element: <h1>Not found page</h1>,
  // },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "aboutus",
        element: <AboutUs />,
      },
      {
        path: "contactus",
        element: <ContactUs />,
      },
      {
        path: "restaurants",
        element: <Restaurant />,
      },
      {
        path: "restaurants/:cuisineId",
        element: <Restaurant />,
      },
      {
        path: "restaurant-details/:outletId",
        element: <RestaurantDetails />,
        children: [
          {
            path: "menu",
            element: <Menu />,
          },
          {
            path: "reviews",
            element: <Reviews />,
          },
          {
            path: "info",
            element: <Info />,
          },
        ],
      },
      {
        path: "checkout",
        element: <Checkout />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "order-status/:id",
        element: <OrderStatus />,
      },
      {
        path: "editprofile",
        element: <EditProfile />,
      },
      {
        path: "favorites",
        element: <Favorites />,
      },
      {
        path: "my-cart",
        element: <MyCart />,
      },
    ],
  },

  // Restaurant details page without header and footer
  {
    path: "restro-menu/:outletId",
    element: <RestaurantData />,
  },

  {
    path: "restro-menu/:outletId/checkout",
    element: <Checkout />,
  },
  {
    path: "restro-menu/profile",
    element: <Profile />,
  },
  {
    path: "restro-order-status/:id",
    element: <OrderStatus />,
  },

]);

function App() {
  // const state = useSelector((state) => state);
  // const dispatch = useDispatch();
  // useLayoutEffect(() => {
  //   const handleResize = () => {
  //     if (window.innerWidth > 991) dispatch(updateDesktopMode(true));
  //     else dispatch(updateDesktopMode(false));
  //   };
  //   window.addEventListener("resize", handleResize);
  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, []);





  /////////////////////////////

  const state = useSelector((state) => state);
  const isDesktopMode = useSelector((state) => state.general.isDesktopMode);
  const dispatch = useDispatch();
  useLayoutEffect(() => {
    const handleResize = () => {
      if (isDesktopMode && window.innerWidth > 991) {

        dispatch(updateDesktopMode(true));

      }
      else if (isDesktopMode && window.innerWidth <= 991) {

        dispatch(updateDesktopMode(false));

      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isDesktopMode]);


  ////////////////////////////

  return (
    <>
      {state.auth.isLoading && <Spinner />}
      <RouterProvider router={router} />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
